export enum AxiomaW1NominalDiameter {
  DN25 = 25,
  DN32 = 32,
  DN40 = 40,
  DN50 = 50
}
